import { CareerItemModel } from "./CareerItemModel";

export class CareerListModel {
    constructor(public careers: CareerItemModel[]){}
}